/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ConfirmModalGeneralModel} from './confirm-modal-general.model';

// FIXME: CTWILS-2360
@Component({
    selector: 'app-confirm-modal-general',
    templateUrl: './confirm-modal-general.component.html',
    styleUrls: ['./confirm-modal-general.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
// FIXME: CTWILS-2360
/**
 * @deprecated
 */
export class ConfirmModalGeneralComponent {
    @Input() title: string;
    @Output() confirmEvent = new EventEmitter<any>();

    constructor(public activeModal: NgbActiveModal) {
    }

    initModal(confirmModal: ConfirmModalGeneralModel): ConfirmModalGeneralComponent {
        this.title = confirmModal.title;
        // FIXME: CTWILS-2360
        return this;
    }

    clickPrimaryButton(): void {
        this.confirmEvent.emit(true);
        this.activeModal.dismiss();
    }
}
